import { useLocation, useNavigate } from "react-router-dom";
import Topheader from "../../component/Topheader";
import { useEffect, useState, useCallback } from "react";
import { apiClient } from "../../config";

const Startups = () => {
  // const [token, setToken] = useState(null);
  const [startupData, setStartupData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const limit = 9;
  const location = useLocation();
  const navigate = useNavigate();

  // Dashboard se aaye hue plan ko safely extract karna
  const currentPlan = location.state?.plan || "all";

  // 1. Initial Token Load
  // useEffect(() => {
  //   const storedToken =
  //     sessionStorage.getItem("token") || localStorage.getItem("token");
  //   if (storedToken) {
  //     setToken(storedToken);
  //   } else {
  //     navigate("/login"); // Agar token nahi hai toh login pe bhej dein
  //   }
  // }, [navigate]);

  // 2. Fetch Data Logic (Optimized with useCallback)
  const handleFetchStartupData = useCallback(async () => {
    // if (!token) return;

    setLoading(true);
    try {
      const response = await apiClient.get(
        `/api/admin_routes/startups/${currentPlan}?page=${page}&limit=${limit}`,
      );

      // Backend response structure matching
      setStartupData(response.data.startups || []);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      console.error(
        "❌ Fetch Error:",
        error?.response?.data?.message || error.message,
      );
      setStartupData([]);
    } finally {
      setLoading(false);
    }
  }, [currentPlan, page]); // In teeno ke badalne par hi function update hoga

  // 3. Trigger Fetch on Change
  useEffect(() => {
    handleFetchStartupData();
  }, [handleFetchStartupData]);

  return (
    <div className="min-vh-100">
      {/* <Topheader /> */}
      <div className=" mt-3">
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-0 text-dark" style={{ color: "#1e293b" }}>Startups Management</h2>
              <p className="text-muted small" style={{ color: "#64748b" }}>
                Showing Startups for:{" "}
                <span className="badge bg-primary text-capitalize">
                  {currentPlan}
                </span>
              </p>
            </div>
            <button
              className="btn btn-outline-secondary btn-sm px-3 shadow-sm"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left me-1"></i> Back
            </button>
          </div>
          <hr />

          {/* Data Rendering */}
          {loading ? (
            <div className="text-center p-5 mt-5">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              ></div>
              <p className="mt-3 text-muted">Loading Startups...</p>
            </div>
          ) : startupData.length > 0 ? (
            <div className="row">
              {startupData.map((s) => (
                <div className="col-lg-4 col-md-6 mb-4" key={s._id}>
                  <div
                    className="card shadow-sm border-0 h-100 startup-card"
                    style={{ transition: "all 0.3s ease", cursor: "pointer" }}
                    onClick={() => navigate(`/startup_detail/${s._id}`)} // Fixed: Dynamic URL params
                  >
                    <div className="card-body p-4 text-center">
                      {/* Logo Section */}
                      <div className="mb-3 d-flex justify-content-center">
                        {s.logoUrl ? (
                          <img
                            src={s.logoUrl}
                            alt="logo"
                            className="rounded shadow-sm"
                            style={{
                              height: "70px",
                              width: "70px",
                              objectFit: "contain",
                              background: "#f8f9fa",
                              padding: "5px",
                            }}
                          />
                        ) : (
                          <div
                            className="bg-primary text-white rounded shadow-sm d-flex align-items-center justify-content-center"
                            style={{
                              width: "70px",
                              height: "70px",
                              fontSize: "22px",
                              fontWeight: "bold",
                            }}
                          >
                            {s.startupName?.substring(0, 2).toUpperCase()}
                          </div>
                        )}
                      </div>

                      <h5 className="fw-bold mb-1 text-dark text-truncate">
                        {s.startupName}
                      </h5>
                      <p className="text-muted small mb-3">
                        {s.industry || "General Industry"}
                      </p>

                      <div 
                        className="text-start p-3 rounded-3 small"
                        style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}
                      >
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Founder:</span>
                          <span className="fw-semibold text-dark" style={{ color: "#1e293b" }}>
                            {s.firstName} {s.lastName}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-2 text-truncate">
                          <span className="text-muted">Email:</span>
                          <span className="fw-semibold text-primary" style={{ color: "#435ebe" }}>
                            {s.email}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Plan:</span>
                          <span
                            className={`badge ${s.selectedPlan === "alpha" ? "bg-warning text-dark" : "bg-info text-dark"} text-capitalize`}
                          >
                            {s.selectedPlan || "Free"}
                          </span>
                        </div>
                      </div>

                      <div className="mt-3 pt-2 border-top">
                        <span className="text-primary fw-semibold small d-inline-flex align-items-center gap-1">
                          View Details <i className="bi bi-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Pagination Section */}
              <div className="d-flex justify-content-center mt-4 gap-2 mb-5">
                <button
                  className="btn btn-white border shadow-sm px-4"
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                >
                  Previous
                </button>
                <div className="align-self-center px-3 fw-bold bg-white border py-2 rounded shadow-sm">
                  Page {page} of {totalPages}
                </div>
                <button
                  className="btn btn-white border shadow-sm px-4"
                  disabled={page === totalPages}
                  onClick={() => {
                    setPage((p) => p + 1);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <div className="text-center p-5 bg-white rounded shadow-sm">
              <h4 className="text-muted">No Startups Found</h4>
              <p>No records match the "{currentPlan}" filter.</p>
              <button className="btn btn-primary" onClick={() => navigate(-1)}>
                Go Back
              </button>
            </div>
          )}
      </div>

      {/* Internal CSS for Hover effects */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .startup-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 10px 20px rgba(0,0,0,0.12) !important;
            border: 1px solid #0d6efd !important;
          }
      `,
        }}
      />
    </div>
  );
};

export default Startups;
